import React, { PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import Modal from '../../../components/Modal'
import Button from '../../../components/Button'
import Input from '../../../components/Input'
import { Colors, Metrics } from '../../../Themes'

const CustomInput = styled(Input)`
  .inputTitle {
    color: ${Colors.primary};
  }
`

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.large};
`

const MoreSettings = props => {
  const { profile, t, handleChange, next, router } = props
  return (
    <Modal
      visible
      closeAction={() => router.push('/landing')}
      header={<div className={'header'}>{t('More Info')}</div>}
      backAction={router.goBack}>
      <CustomInput
        width={'100%'}
        title={t('Who recommended HvB to you?')}
        placeholder={t('Name')}
        key='recommendedBy'
        handleChange={event => handleChange('recommendedBy', event)}
      />

      <CustomButton
        label={'Next'}
        onClick={() => {
          if (profile.linkedinId) {
            next('/landing/signup/terms')
          } else {
            next('/landing/signup/password')
          }
        }}
      />
    </Modal>
  )
}

MoreSettings.propTypes = {
  handleChange: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  router: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  MoreSettings
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/MoreSettings.js